import { t } from "@lingui/macro";
import * as Clipboard from "expo-clipboard";
import { useCallback } from "react";

import {
  AlertIcon,
  DuplicateIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";
import {
  VStack,
  Text,
  HStack,
  Pressable,
  Box,
} from "@whoosh/design-system/src/components/primitive";

import { SignOutButton } from "../../SignOutButton";

export const ErrorDisplayingFallback = ({
  eventId,
  resetError,
}: {
  error?: unknown;
  eventId: string;
  resetError: () => void;
}) => {
  const { showToast } = useToast();
  const copyToClipboard = useCallback(async () => {
    await Clipboard.setStringAsync(eventId);

    showToast({
      semanticStyle: "success",
      title: t`Event Id copied to clipboard.`,
      description: t`Thanks for passing that one along!`,
    });
  }, [eventId, showToast]);

  const currentMessage = `Whoops! Something didn't work.`;

  return (
    <VStack alignItems={"center"} paddingTop={8}>
      <VStack
        backgroundColor="surface-primary"
        alignItems={"center"}
        maxWidth={450}
        padding={4}
        paddingBottom={6}
        borderRadius="2"
      >
        <AlertIcon width={48} height={48} color="error.400" />
        <Text textAlign="center" variant="mainTitle3">
          {currentMessage}
        </Text>
        <Pressable onPress={copyToClipboard}>
          <HStack
            borderWidth={1}
            borderRadius="2"
            borderColor="outline-status-error"
            backgroundColor="surface-status-error-subtler"
            padding={2}
            marginTop={4}
            marginBottom={4}
            gap={1}
          >
            <Text color="text-error">{t`Event Id: ${eventId}`}</Text>
            <DuplicateIcon color="status-error-500" />
          </HStack>
        </Pressable>
        <Text textAlign="center">{t`We're sorry, but something went wrong. Pass that Event Id along to our support staff, and we'll dig right in, or, you could try logging out to see if it resolves the issue.`}</Text>
        <Box paddingTop={6}>
          <SignOutButton resetError={resetError} />
        </Box>
      </VStack>
    </VStack>
  );
};
